import { memo, useEffect, useRef } from "react";
import avatarImg from "../../../../shared/assets/img/bot-avatar.png";
import { AppMarkdownParser } from "../../../../shared/components/AppMarkdownParser";
import { CopyButton } from "../../../Components/Buttons/CopyButton";
import styles from "./styles.module.css";

interface Props {
  systemMessage: string;
  onFileClick?: (url: string, filename: string) => void;
}

const SystemMessageInner = ({ systemMessage, onFileClick }: Props) => {
  const iconRef = useRef<HTMLImageElement>(null);
  const messageRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    scrollToBottom();
  }, [systemMessage]);

  const scrollToBottom = () => {
    iconRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className={styles.wrapper}>
      <img
        ref={iconRef}
        src={avatarImg}
        alt="Иконка искр для обозначения системного сообщения"
        className={styles["system-avatar"]}
      />
      <div ref={messageRef} className={styles["system-message"]}>
        <AppMarkdownParser content={systemMessage} onFileClick={onFileClick} />
      </div>
      <CopyButton
        copyObjectRef={messageRef}
        copyFormat={"both"}
        className={styles["message-copy-button"]}
      />
    </div>
  );
};

export const SystemMessage = memo(SystemMessageInner);
